import React from 'react'

const ModalGuide = ({content, direction, statePrev, stateNext, last, start}) => {
    return (
      <div className={`animated fadeIn ${start ? "modal-help-start" : "modal-help"} ${direction}`}>
          {content}
        <div className="modal-help-footer">
          <div onClick={()=>{statePrev(false);}} className="modal-help-btn">Omitir</div>
          { last ? <div onClick={()=>{statePrev(false); stateNext(false);}} className="modal-help-btn">Finalizar</div>
          : <div onClick={()=>{statePrev(false); stateNext(true);}} className="modal-help-btn">Siguiente</div> }
        </div>
      </div>
    )
}

export default ModalGuide